export default {
  collectionColumn: {
    title: 'Collection Column',
    id: 'Id',
    columnName: 'Column name',
    columnTitleEn: 'Column title in English',
    columnTitleKo: 'Column title in Korean',
    columnTitleVi: 'Column title in Vietnamese',
    allowDisplayCollection: 'Allow display collection',
    allowDisplayFraudDetail: 'Allow display fraud detail',
    allowDisplayFraudList: 'Allow display fraud list',
    allowSearch: 'Allow search',
    allowValidatedCollector: 'Allow validated collector',
    allowValidatedConsole: 'Allow validated console',
    dataType: 'Data type',
    dataLength: 'Data length',
    dataValueMin: 'Data value min',
    dataValueMax: 'Data value max',
    dataValidatedTemplate: 'Data validated template'
  }
}